import { useEffect, useState } from 'react';

/**
 * Reads /api/config/notifications and returns which channels are enabled for
 * a given event. The values reflect what admin set in the Notifications page.
 * Used by per-action notify checkboxes so they can label themselves "(email + SMS)"
 * or disable themselves entirely when nothing is enabled.
 *
 * Returns { email: bool, sms: bool, loaded: bool }. Defaults email=true / sms=false
 * before the fetch lands (matches the seeded config defaults).
 */
export default function useNotificationChannels(event, API, authHeader) {
  const [state, setState] = useState({ email: true, sms: false, loaded: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}/config/notifications`, { headers: { ...authHeader() } });
        if (!res.ok) return;
        const json = await res.json();
        if (cancelled) return;
        setState({
          email: !!json.toggles?.email?.[event],
          sms: !!json.toggles?.sms?.[event],
          loaded: true,
        });
      } catch { /* keep defaults */ }
    })();
    return () => { cancelled = true; };
  }, [event, API]);

  return state;
}
